import { render, staticRenderFns } from "./detalleGestion.vue?vue&type=template&id=7a4b10a5&scoped=true"
import script from "./detalleGestion.vue?vue&type=script&lang=js"
export * from "./detalleGestion.vue?vue&type=script&lang=js"
import style0 from "./detalleGestion.vue?vue&type=style&index=0&id=7a4b10a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b10a5",
  null
  
)

export default component.exports